import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'no-permission',
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss']
})
export class NoPermissionComponent implements OnInit {
  @Input() reason: string = 'You can return to what you were viewing previously by using the browsers back button. ';

  constructor() { }

  ngOnInit() {
  }

}
